import LoadingCircular from './LoadingCircular';

export default LoadingCircular;
